import { Checkbox as RoccoCheckbox } from '@rocco/components/checkbox';
import { cn } from '@rocco/utils/cn';

/** Shared opt-in copy for HDE registration (homeowner auth + pro/exhibitor company details). */
const HDE_REGISTRATION_MARKETING_CONSENT_LABEL =
    'I agree to receive registration communications about this event and related updates from ArchiPro.';

interface HdeRegistrationMarketingConsentProps {
    /** Distinct per screen for label/checkbox association (accessibility). */
    id: string;
    checked: boolean;
    onCheckedChange: (checked: boolean) => void;
    /** When set, displays a red validation message below the checkbox. */
    errorMessage?: string;
}

/**
 * Checkbox + label for HDE event registration marketing consent; styling matches homeowner auth.
 */
export function HdeRegistrationMarketingConsent({
    id,
    checked,
    onCheckedChange,
    errorMessage,
}: HdeRegistrationMarketingConsentProps) {
    return (
        <div className="flex flex-col gap-1 opacity-80">
            <div className="flex flex-row items-start gap-2">
                <RoccoCheckbox
                    id={id}
                    checked={checked}
                    onCheckedChange={(value) => onCheckedChange(value === true)}
                    className="relative top-0.5 size-3 rounded-[0.15rem]"
                    indicatorClassName="-translate-y-px"
                />
                {/* FormLabel requires FormProvider; company-details step has none. */}
                <label
                    htmlFor={id}
                    className={cn(
                        '!mt-0 block w-71 cursor-pointer text-[0.875rem] leading-[1.02] text-[#2a2a2a]',
                    )}
                >
                    {HDE_REGISTRATION_MARKETING_CONSENT_LABEL}
                </label>
            </div>
            {errorMessage && (
                <p
                    className="pl-5 text-[0.8125rem] leading-tight text-red-600"
                    role="alert"
                >
                    {errorMessage}
                </p>
            )}
        </div>
    );
}
